export const environment = {
  production: true,
  baseURL: '#{baseURL}#',
  version: '#{version}#',
  browserTabTitel: '#{browserTabTitel}#'
};
